// extracted by mini-css-extract-plugin
module.exports = {"exchange-code-container":"ExchangeCode_exchange-code-container__Q97dV","exchange-tip-text":"ExchangeCode_exchange-tip-text__5WRz_"};